import React from 'react';
import { Link } from 'react-router-dom';

import Main from '../layouts/Main';

const Index = () => (
  <Main
    description={"Anand Gokul's personal website. SF Bay Area based Software Engineer, "
      + 'latest Tech enthusiast!'}
  >
    <article className="post" id="index">
      <header>
        <div className="title">
          <h2 data-testid="heading"><Link to="/">About this site</Link></h2>
          <p>
            A ReactJS based application to present my portfolio to the world.
          </p>
        </div>
      </header>
      <p> Welcome to my website. Please feel free to read more <Link to="/about">about me</Link>,
        or you can check out my {' '}
        <Link to="/resume">resume</Link>, {' '}
        <Link to="/projects">projects</Link>, {' '}
        view some fun <Link to="/stats">statistics</Link>, {' '}
        or <Link to="/contact">contact</Link> me.
      </p>
      <p> This site is hosted on <a href="https://netlify.com">Netlify</a>, the domain is registered on <a href="https://squarespace.com">Square Space</a> , the email is hosted on <a href="https://zoho.com">Zoho</a>, the analytics is hosted serverless on <a href="https://firebase.google.com/">Google Firebase </a>, and the SSL/TLS certificate is provided by <a href="https://letsencrypt.org">Let's Encrypt</a>.</p>
    </article>
  </Main>
);

export default Index;
